module.exports = __webpack_public_path__ + "506aaf7f49928f0a3798f6acbc0dbd14.woff2";